export const Vacancies = [
  {
    id: 1,
    position: 'Operator Account Manager',
    location: 'Georgia',
    jobType: 'Full Time',
    department: 'Strategy',
    date: '15.05.2025 - 15.07.2025',
    content: `<h1 class="font-bold text-xl text-left">Operator Account Manager – iGaming</h1>
    <p class="font-normal text-base mb-6">
    We are seeking a highly experienced Operator Account Manager to join our growing team in Tbilisi, Georgia, and take ownership of key operator relationships within the iGaming sector. This role is ideal for someone who understands the dynamics of affiliate marketing, is revenue-driven, and knows how to build long-term partnerships that deliver measurable results. You will manage a portfolio of operator accounts, drive growth through data-centric strategies, and help scale our affiliate program globally. If you thrive in a fast-paced, high-performance environment and understand the nuances of iGaming affiliation, we want to hear from you.
    </p>
    
    <h1 class="font-bold text-xl text-left">Key Responsibilities</h1>
    <p class="font-normal text-base mb-6">
    ● Manage and grow a portfolio of operator partners within the iGaming space<br>
    ● Cultivate and maintain strong, long-term relationships with operators and key stakeholders<br>
    ● Identify new opportunities for growth within existing partnerships and seek out new high-value operators<br>
    ● Negotiate and optimize commercial agreements to maximize ROI<br>
    ● Monitor operator performance and provide regular, data-driven performance reports<br>
    ● Collaborate with internal teams including product, marketing, compliance, and finance to align on campaign goals<br>
    ● Attend industry events, conferences, and meetings to represent the brand and strengthen relationships<br>
    ● Stay up to date with market trends and competitor activity to ensure strategic positioning
    </p>
    
    <h1 class="font-bold text-xl text-left">Must Have</h1>
    <p class="font-normal text-base mb-6">
    ● Minimum 5 years of proven experience in operator account management in the iGaming industry<br>
    ● Deep understanding of online gambling products (Casino, Sportsbook, etc.) and affiliate ecosystems<br>
    ● Strong negotiation, analytical, and problem-solving skills<br>
    ● Results-oriented mindset with a focus on revenue growth and partner success<br>
    ● Ability to work independently, take initiative, and manage multiple projects in a dynamic environment<br>
    ● Excellent interpersonal and communication skills (written and verbal)<br>
    ● Experience with affiliate platforms and analytics tools (e.g., NetRefer, Income Access)<br>
    ● Willingness to travel to industry events as required
    </p>
    
    <h1 class="font-bold text-xl text-left">What Success Looks Like</h1>
    <p class="font-normal text-base mb-6">
    ● Increased affiliate-driven revenue and improved partner performance<br>
    ● Strong, trust-based relationships with affiliates and internal stakeholders<br>
    ● Clear and timely reporting of KPIs, insights, and optimization plans<br>
    ● Ability to identify and scale high-potential affiliate partnerships<br>
    ● Active participation in the affiliate and iGaming community
    </p>    
      `,
  },
];
